export class SocialLogins
{
    firstnameparm:string;
    lastnameparm:string;
    emailparm:string;
    usernameparm:string;
    passwordparm:string;
    usertypeidparm:string;
    socialusersparm:string;
    issubscribedparam:string;
    isverifiedparam:string;
    userid:string;
}

export class actors {
actorid:string;
name:string;
numberType:string;
descripton:string;
}
export interface DropDownList {
    code: any
    text: any
  }
